export default __webpack_public_path__ + "static/media/paypal.3bc0da98.png";